import {
  Grid as GridBase,
  Paper,
  Typography as TypographyBase,
} from "@mui/material";
import React from "react";
import { CurrencyFormateText } from "@/components/CurrencyFormat";

type ConfirmLocationTotalProps = {
  totalBudget?: string | number;
  text?: string;
  textColor?: string;
};

const Grid = GridBase as React.ComponentType<Record<string, any>>;
const Typography = TypographyBase as React.ComponentType<Record<string, any>>;

function ConfirmLocationTotal({
  totalBudget = 0,
  text = "Total Budget:",
  textColor = "default",
}: ConfirmLocationTotalProps) {
  return (
    <Paper className="my-1 px-2 py-3" elevation={2}>
      <Grid container spacing={1} justifyContent="flex-end">
        <Grid item size={{ md: "grow" }}>
          <Typography
            variant="body1"
            className="text-right"
            sx={{ fontWeight: 600 }}
            color={textColor}
          >
            {text}
          </Typography>
        </Grid>
        <Grid item size={{ md: 2 }}>
          <Typography
            variant="body1"
            color="text.primary"
            className="text-center"
            sx={{ fontWeight: 700 }}
          >
            <CurrencyFormateText value={totalBudget} suffix=" USD" />
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
}

export default ConfirmLocationTotal;
